import React from 'react';
import styled from 'styled-components';
import { FaCheckCircle } from 'react-icons/fa';
import usePasswordCheck from '../../../hooks/usePasswordCheck';

const PasswordTooltip = ({ password, isSmallScreen }: PasswordTooltipProps) => {
	const { includeUpperAndLowerCase, includeAtLeastOneNumber, hasEightOrMoreCharacters } = usePasswordCheck(password);

	return (
		<>
			<PasswordTooltipContainer isSmallScreen={isSmallScreen}>
				<PasswordRequirement isSmallScreen={isSmallScreen}>
					<CheckIcon checked={includeUpperAndLowerCase} />
					Includes lower and upper case
				</PasswordRequirement>
				<PasswordRequirement isSmallScreen={isSmallScreen}>
					<CheckIcon checked={includeAtLeastOneNumber} />
					Includes at least one number
				</PasswordRequirement>
				<PasswordRequirement isSmallScreen={isSmallScreen}>
					<CheckIcon checked={hasEightOrMoreCharacters} />
					Password must be 8 or more characters
				</PasswordRequirement>
			</PasswordTooltipContainer>
			<PasswordTooltipArrow isSmallScreen={isSmallScreen} />
		</>
	);
};

export default PasswordTooltip;

interface PasswordTooltipProps {
	password: string;
	isSmallScreen: boolean;
}

const PasswordTooltipContainer = styled.div<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
	position: 'absolute',
	bottom: isSmallScreen ? '59px' : '66px',
	left: isSmallScreen ? '70px' : '75px',
	padding: isSmallScreen ? '6px 12px' : '8px 16px',
	background: theme.colors.lightGreyR,
	borderRadius: '5px',
	zIndex: 50,
}));

const PasswordTooltipArrow = styled.div<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
	position: 'absolute',
	bottom: isSmallScreen ? '50px' : '57px',
	left: isSmallScreen ? '75px' : '80px',
	width: 0,
	height: 0,
	borderLeft: '20px solid transparent',
	borderRight: '20px solid transparent',
	borderTop: '20px solid',
	borderTopColor: theme.colors.lightGreyR,
}));

const PasswordRequirement = styled.p<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
	marginTop: isSmallScreen ? '5px' : '10px',
	marginBottom: isSmallScreen ? '5px' : '10px',
	color: theme.colors.darkR,
	fontSize: isSmallScreen ? '14px' : '18px',
}));

const CheckIcon = styled(FaCheckCircle)<{ checked: boolean }>(({ theme, checked }) => ({
	display: 'inline-block',
	marginRight: '5px',
	color: checked ? '#00b500' : '#a4a6a8',
}));
